<template>
  <el-row>
    <el-col :span="24">
      <hr class="dotted" />
      <div class="form-module-tit">{{ $locale('movie.filmRate') }}</div>

      <el-row>
        <el-col :span="4" :xs="12">
          <el-form-item :label="$locale('global.saletaxRate')" prop="taxRate">
            <TaxSelect v-model="formData.taxRate" :isSaleOption="true"></TaxSelect>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="margin-left: 10px;"><AddBtn @clickAction="addShareData" :data="formData"/></el-col>
      </el-row>

      <template v-if="adminType !== 'superAdmin'">
        <div class="generator-item clearfix" v-for="(item, idx) in formData.share" :key="idx" >
        <el-form-item :label="$locale('movie.startingDay')">
          <ShareDatePicker :formItem='item.shareStartDate' :idx='idx' type='start' @change='changeShareDate' :end='item.shareEndDate' @plusDate='plus(item.shareStartDate, item.shareEndDate, idx, "start")' @reduceDate='reduce(item.shareStartDate, item.shareEndDate, idx, "start")' />
        </el-form-item>
        <el-form-item :label="$locale('movie.endingDay')">
          <ShareDatePicker :formItem='item.shareEndDate' :idx='idx' type='end' @change="changeShareDate" :start='item.shareStartDate' @plusDate='plus(item.shareStartDate, item.shareEndDate, idx, "end")' @reduceDate='reduce(item.shareStartDate, item.shareEndDate, idx, "end")' />
        </el-form-item>
        <el-form-item :label="$locale('movie.mainBusiness')" :prop="`share[${idx}].normalShare`" :rules="shareItemRules">
          <el-input v-model.number="item.normalShare" @input="(e, index) => changeHandler(e, idx)" maxlength="3">
            <p class="percent" slot="suffix">%</p>
          </el-input>
        </el-form-item>
        <el-form-item :label="$locale('movie.morningShow')" :prop="`share[${idx}].morningShare`" :rules="shareItemRules">
          <el-input v-model.number="item.morningShare" @input="(e, index) => changeHandler(e, idx)" maxlength="3">
            <p class="percent" slot="suffix">%</p>
          </el-input>
        </el-form-item>
        <el-form-item :label="$locale('movie.lateShow')" :prop="`share[${idx}].eveningShare`" :rules="shareItemRules">
          <el-input v-model.number="item.eveningShare" @input="(e, index) => changeHandler(e, idx)" maxlength="3">
            <p class="percent" slot="suffix">%</p>
          </el-input>
        </el-form-item>
        <el-form-item :label="$locale('movie.allNight')" :prop="`share[${idx}].overNightShare`" :rules="shareItemRules">
          <el-input v-model.number="item.overNightShare" @input="(e, index) => changeHandler(e, idx)" maxlength="3">
            <p class="percent" slot="suffix">%</p>
          </el-input>
        </el-form-item>
        <el-form-item :label="$locale('movie.specialBusiness')" :prop="`share[${idx}].specialShare`" :rules="shareItemRules">
          <el-input v-model.number="item.specialShare" @input="(e, index) => changeHandler(e, idx)" maxlength="3">
            <p class="percent" slot="suffix">%</p>
          </el-input>
        </el-form-item>
        <el-form-item :label="$locale('movie.flat')" :prop="`share[${idx}].stableMoney`">
          <el-input v-model.number="item.stableMoney" @input="(e) => changePriceHandler(e, idx)" maxlength="20">
            <p class="percent" slot="suffix">{{$locale("movie.circle")}}</p>
          </el-input>
        </el-form-item>
        <!-- <CtrlBtns
          :fieldData="formData.share"
          :index="0"
          @clickAction="operation => shareListingCtrl({ operation, idx })"
        ></CtrlBtns> -->
        <ReduceBtn @clickAction="operation => shareListingCtrl({ operation, idx })" :data="formData" :index="idx" :isBehind="true" />
        <AddBtn @clickAction="operation => shareListingCtrl({ operation, idx })" :data="formData" :index="idx" :isBehind="true" />
        <!-- <a class="operation" @click="decreaseShare(idx)" v-if="formData.share.length > 1">
          <i class="el-icon-minus">&nbsp;</i>
        </a>
        <a class="operation" @click="increaseShare(idx)" v-if="idx === formData.share.length - 1">
          <i class="el-icon-plus">&nbsp;</i>
        </a> -->
      </div>
      </template>
    </el-col>
  </el-row>
</template>

<script>
import ShareDatePicker from "@/components/Use/shareDatePicker";
import TaxSelect from "@/components/common/TaxSelect";
// import CtrlBtns from "./CtrlBtns";
import AddBtn from "./AddBtn.vue";
import ReduceBtn from "./ReduceBtn.vue";
import { toThousands } from "@/utils/common";
import {
  taxRateArrary,
  shareItemRules,
  shareObj,
} from "@/assets/js/movieStatic";

export default {
  name: "film-rate",
  components: {
    ShareDatePicker,
    TaxSelect,
    // CtrlBtns,
    AddBtn,
    ReduceBtn,
  },
  props: {
    formData: {
      required: true,
      type: Object,
    },
    formRef: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      taxRateArrary,
      shareItemRules,
      adminType: window.localStorage.getItem("adminType"),
    };
  },
  methods: {
    changeShareDate(val, idx, type) {
      if (type === "start") {
        this.formData.share[idx].shareStartDate = val;
      } else {
        this.formData.share[idx].shareEndDate = val;
        this.renderDate(idx);
      }
    },
    shareListingCtrl({ operation, idx }) {
      if (operation === "ADD") {
        const _newDate = this.$moment(this.formData.share[idx].shareEndDate).add(1, "days").format("YYYY-MM-DD");

        this.formData.share.push({
          ...shareObj,
          shareStartDate: _newDate,
          shareEndDate: _newDate,
        });

        this.formData.share.forEach((item, idx) => {
          if (idx > 0 && idx === idx + 1) {
            let d = new Date(this.formData.share[idx - 1].shareEndDate);
            d = d.setDate(d.getDate() + 1);
            item.shareStartDate = this.$moment(d).format("YYYY-MM-DD");
            item.shareEndDate = item.shareStartDate;
          }
        });
      } else if (operation === "DEL") {
        // console.log("???")
        this.formData.share.splice(idx, 1);
      }
    },
    renderDate(idx) {
      for (let i = idx; i < this.formData.share.length; i++) {
        if (i + 1 < this.formData.share.length) {
          let d = new Date(this.formData.share[i].shareEndDate);
          d = d.setDate(d.getDate() + 1);
          this.formData.share[i + 1].shareStartDate = this.$moment(d).format("YYYY-MM-DD");
          this.formData.share[i + 1].shareEndDate = this.formData.share[i + 1].shareStartDate;
        }
      }
    },
    plus(start, end, idx, type) {
      if (type === "start") {
        let startDate = new Date(start);
        let endDate = new Date(end);
        startDate.setDate(startDate.getDate() + 1);
        this.formData.share[idx].shareStartDate = this.$moment(startDate).format("YYYY-MM-DD");
        if (startDate > endDate) {
          this.formData.share[idx].shareEndDate = this.formData.share[idx].shareStartDate;
          this.renderDate(idx);
        }
      } else {
        let d = new Date(end);
        d.setDate(d.getDate() + 1);
        this.formData.share[idx].shareEndDate = this.$moment(d).format("YYYY-MM-DD");
        this.renderDate(idx);
      }
    },
    reduce(start, end, idx, type) {
      let startDate = new Date(start);
      let endDate = new Date(end);
      if (type === "start") {
        if (idx > 0) {
          let d = new Date(this.formData.share[idx - 1].shareEndDate);
          d.setDate(d.getDate() + 1);
          if (startDate <= d) {
            return;
          }
        }
        startDate.setDate(startDate.getDate() - 1);
        this.formData.share[idx].shareStartDate = this.$moment(startDate).format("YYYY-MM-DD");
      } else {
        let d = new Date(end);
        d.setDate(d.getDate() - 1);
        if (endDate > startDate) {
          this.formData.share[idx].shareEndDate = this.$moment(d).format("YYYY-MM-DD");
          this.renderDate(idx);
        }
      }
    },
    changeHandler(val, idx) {
      this.formData.share[idx].stableMoney = null;
    },
    changePriceHandler(val, idx) {
      this.formData.share[idx].eveningShare = 0;
      this.formData.share[idx].morningShare = 0;
      this.formData.share[idx].normalShare = 0;
      this.formData.share[idx].overNightShare = 0;
      this.formData.share[idx].specialShare = 0;
      this.formData.share[idx].stableMoney = toThousands(parseInt(val.replace(/,/g, "")));
    },
    addShareData() {
      this.formData.share.push(shareObj);
    },
    reduceShareData(idx) {
      this.formData.share.splice(idx, 1);
    }
  },
};
</script>